import type { SecurityType } from '@dealstack/prisma-client';

export const getSecurityTypeFromTypeName = (translation: string): SecurityType | undefined => {
	switch (translation) {
		case 'Ordinary share':
			return 'ORDINARY_SHARE';
		case 'Preference share':
			return 'PREFERENCE_SHARE';
		case 'Loan':
			return 'LOAN';
		case 'Partnership Unit':
			return 'PARTNERSHIP_UNIT';
		case 'Tracking share':
			return 'TRACKING_SHARE';
		case 'Options':
			return 'OPTIONS';
		case 'Other (debt)':
			return 'OTHER';
		case 'Virtual equity':
			return 'VIRTUAL_EQUITY';
		case 'Warrant':
			return 'WARRANT';
		case 'Other (equity)':
			return 'OTHER_EQUITY';
		default:
			return undefined;
	}
};

export const getSecurityTypeNameFromType = (securityType: SecurityType): string | undefined => {
	switch (securityType) {
		case 'ORDINARY_SHARE':
			return 'Ordinary share';
		case 'PREFERENCE_SHARE':
			return 'Preference share';
		case 'LOAN':
			return 'Loan';
		case 'PARTNERSHIP_UNIT':
			return 'Partnership Unit';
		case 'TRACKING_SHARE':
			return 'Tracking share';
		case 'OPTIONS':
			return 'Options';
		case 'VIRTUAL_EQUITY':
			return 'Virtual equity';
		case 'OTHER':
			return 'Other (debt)';
		case 'OTHER_EQUITY':
			return 'Other (equity)';
		case 'WARRANT':
			return 'Warrant';
		default:
			return undefined;
	}
};

export enum SecurityEventType {
	SPLIT = 'SPLIT',
	REVERSE_SPLIT = 'REVERSE_SPLIT',
	ADJUST = 'ADJUST',
	CONVERSION = 'CONVERSION',
}

export const ISSUED_IN_CURRENCY_DEFAULT_SECURITY_TYPES: SecurityType[] = ['OTHER', 'LOAN', 'BOND'];

export const RIGHTS_TO_RESIDUE_TRUE_DEFAULT_SECURITY_TYPES: SecurityType[] = [
	'ORDINARY_SHARE',
	'TRACKING_SHARE',
	'PARTNERSHIP_UNIT',
	'VIRTUAL_EQUITY',
	'OTHER_EQUITY',
];

export const EQUITY_BASIS_UNITS_DEFAULT_SECURITY_TYPES: SecurityType[] = [
	'ORDINARY_SHARE',
	'TRACKING_SHARE',
	'VIRTUAL_EQUITY',
	'OTHER_EQUITY',
];

export const EQUITY_BASIS_COST_AT_ISSUE_DEFAULT_SECURITY_TYPES: SecurityType[] = [
	'PARTNERSHIP_UNIT',
];

export const SECURITY_FRACTIONAL_DENOMINATOR_VALUES = [10, 100, 1000, 10000, 100000];
